import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import PropTypes from 'prop-types';
import client from '../../client';
import { customSelectStyles, mapTagsFromAPIRequest } from '../../utils';
import { GET_BRANDS_CATEGORY_TAGS } from '../../graphql-client/queries';

function CategoryTagSelect(props) {
  const {
    initialData, placeholder, handleSelectedCategories, value,
  } = props;

  const [selectedTags, setSelectedTags] = useState(null);
  const loadOptions = async (input) => {
    if (input && input.trim().length < 2) {
      return mapTagsFromAPIRequest(initialData);
    }
    const res = await client.query({
      query: GET_BRANDS_CATEGORY_TAGS,
      variables: { isCategory: true, searchKey: input },
    });
    const resData = res.data.getCategoryTags;
    if (resData && resData.data) {
      return mapTagsFromAPIRequest(resData.data);
    }
    return [];
  };

  const handleCategoryChange = (selectedOption) => {
    setSelectedTags(selectedOption);
  };

  useEffect(() => {
    handleSelectedCategories(selectedTags);
  }, [selectedTags]);

  return (
    <div>
      <AsyncSelect
        className="reactSelect multiSelect"
        styles={customSelectStyles}
        cacheOptions
        placeholder={placeholder}
        loadOptions={loadOptions}
        value={selectedTags || value}
        onChange={handleCategoryChange}
        defaultOptions
        isMulti
      />
    </div>
  );
}

CategoryTagSelect.propTypes = {
  initialData: PropTypes.array,
  placeholder: PropTypes.string,
  handleSelectedCategories: PropTypes.func.isRequired,
  value: PropTypes.any.isRequired,
};

CategoryTagSelect.defaultProps = {
  placeholder: '',
  initialData: [],
};

export default CategoryTagSelect;
